import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { FormControl, InputLabel, Input, makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  formControl: {
    margin: 0,
    minWidth: 120,
    width: '100%',
    // Standard Input adds 16px top margin for a floating label; we overlay the
    // label on the grey field instead (same chrome as PickerSelect).
    '& .MuiInput-formControl': {
      marginTop: 0,
    },
    // Empty label sits in the grey box, 10px inset to match Input paddingLeft.
    // z-index keeps it above the Input background (otherwise the grey fill hides it).
    '& .MuiInputLabel-formControl': {
      transform: 'translate(10px, 9px) scale(1)',
      zIndex: 2,
      pointerEvents: 'none',
    },
    // Focused/filled label floats above the field, flush with the input's left edge.
    '& .MuiInputLabel-shrink': {
      transform: 'translate(0px, -14px) scale(0.75)',
    },
  },
  input: {
    backgroundColor: '#EEEEEE',
    paddingLeft: 10,
  },
});

/**
 * Underlined MUI Input used on staffing list filter rows (same chrome as PickerSelect).
 * Pass `value` to make it controlled. `formControlClassName` can zero extra margin when
 * the field must line up with a grid of cards.
 *
 * @param {{ onChange: Function, label: string, name: string, type?: string, inputProps?: object, value?: string|number, formControlClassName?: string }} props
 */
const StaffingInputFilter = ({
  onChange,
  label,
  name,
  type,
  inputProps,
  value,
  formControlClassName,
}) => {
  const classes = useStyles();
  const [focused, setFocused] = useState(false);
  // Drive shrink ourselves: overlay labels sit on top of the input, so FormControl
  // can miss native focus from a label click. Float when focused or when there is text.
  const shrink = focused || (value !== undefined && String(value).length > 0);

  return (
    <FormControl variant="standard" className={cx(classes.formControl, formControlClassName)}>
      <InputLabel htmlFor={name} shrink={shrink}>
        {label}
      </InputLabel>
      <Input
        id={name}
        classes={{
          root: classes.input,
        }}
        type={type}
        onChange={onChange}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        inputProps={inputProps}
        {...(value !== undefined ? { value } : {})}
      />
    </FormControl>
  );
};

StaffingInputFilter.propTypes = {
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  type: PropTypes.string,
  inputProps: PropTypes.object,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  formControlClassName: PropTypes.string,
};

export default StaffingInputFilter;
